
const data = [
  {value: 'Salud', label: 'Salud'},
  {value: 'Familiar', label: 'Familiar'},
  {value: 'Deporte', label: 'Deporte'},
  {value: 'Personal', label: 'Personal'},
  {value: 'Viaje', label: 'Viaje'}
]
export default data